import {
  getAnacapriElementsConfig
} from "./anacapri-chunk.VM5XEEU5.js";
import {
  Logger_default
} from "./anacapri-chunk.J7V767XI.js";
import {
  tr
} from "./anacapri-chunk.7OQQIROZ.js";

// src/utilities/customElement.ts
function attemptDefineCustomElement(tagName, anacapriElementClass) {
  const { elementPrefix } = getAnacapriElementsConfig();
  const elementName = elementPrefix ? `${elementPrefix}-${tagName}` : tagName;
  anacapriElementClass.tagName = elementName;
  anacapriElementClass.tag = tr(elementName);
  const definedElement = customElements.get(elementName);
  if (definedElement) {
    const definedVersion = definedElement?.version;
    const attemptedVersion = anacapriElementClass?.version;
    if (definedVersion && attemptedVersion && definedVersion === attemptedVersion) {
      Logger_default.log(
        `attempted redefine of "${elementName}" with same version. We recommend only defining elements once per application.`
      );
      return;
    }
    if (definedVersion && attemptedVersion) {
      const [definedMajor, definedMinor] = definedVersion.split(/\.|-/g);
      const [attemptedMajor, attemptedMinor] = attemptedVersion.split(/\.|-/g);
      if (definedMajor !== attemptedMajor || definedMinor < attemptedMinor) {
        Logger_default.logError(
          `attempted redefine of "${elementName}" with version mismatch, update required:
	Version currently defined: ${definedVersion}
	Version attempted to define: ${attemptedVersion}

These versions are incompatible and continuing will result in elements not working as expected, update versions to match.

Get in touch with FED on Slack #anacapri (https://auto-owners.slack.com/archives/CPJ9QQKPY) if you need assistance.`
        );
      } else {
        Logger_default.logWarning(
          `attempted redefine of "${elementName}" with version mismatch, update recommended:
	Version currently defined: ${definedVersion}
	Version attempted to define: ${attemptedVersion}

These versions are compatible and shouldn't result in any issues, but we recommend targeting a single version per application.

Get in touch with FED on Slack #anacapri (https://auto-owners.slack.com/archives/CPJ9QQKPY) if you need assistance.`
        );
      }
      return;
    }
    Logger_default.logError(
      `${elementName} was already defined, but versions weren't able to be compared for compatibility.`
    );
  } else {
    customElements.define(elementName, anacapriElementClass);
    Logger_default.logInfo(`${elementName} (${anacapriElementClass.version}) defined`);
  }
}
function customElement(tagName) {
  return (classOrTarget) => {
    attemptDefineCustomElement(tagName, classOrTarget);
  };
}
var customElement_default = customElement;

export {
  customElement_default
};
